var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImtoken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00793457,
    y: 0.435547,
    width: 39.6474,
    height: 39.6474,
    rx: 19.8237,
    fill: "url(#paint0_linear_72_3156)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.518 13.4704C32.2928 23.6828 25.547 28.5097 19.4996 29.0244C13.8773 29.5029 8.58506 26.141 8.12078 20.9757C7.73779 16.7083 10.4481 14.8916 12.5775 14.7105C14.7677 14.5237 16.6081 15.9935 16.7677 17.773C16.9215 19.484 15.8245 20.2628 15.0615 20.3276C14.4581 20.379 13.699 20.0225 13.6304 19.2571C13.5717 18.5995 13.8283 18.5098 13.7656 17.8112C13.654 16.5673 12.5393 16.4224 11.9291 16.4739C11.1905 16.5368 9.85056 17.3756 10.0386 19.465C10.2277 21.5724 12.3042 23.2376 15.0262 23.006C17.9637 22.7563 20.0089 20.5306 20.1627 17.409C20.1613 17.2436 20.1971 17.0799 20.2675 16.9295L20.2685 16.9257C20.3001 16.8603 20.3371 16.7975 20.3792 16.7379C20.4419 16.6464 20.5222 16.5454 20.626 16.4348C20.627 16.4319 20.627 16.4319 20.629 16.4319C20.7043 16.349 20.7955 16.2594 20.8983 16.1631C22.1814 14.985 26.8027 12.2065 31.1732 13.0863C31.2655 13.1055 31.349 13.1533 31.4112 13.2226C31.4733 13.2918 31.5108 13.3787 31.518 13.4704Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_3156",
    x1: 35.5661,
    y1: 9.89487,
    x2: 1.75888,
    y2: 23.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImtoken);
export default __webpack_public_path__ + "static/media/imtoken.5750905499a782328ebbc948579f7eae.svg";
export { ForwardRef as ReactComponent };